import { appPaths } from "../../Common";
import { BreadcrumbMap } from "../../Layout";

export const breadcrumbsMap: BreadcrumbMap = {
  [appPaths.workflows.edit]: {
    path: appPaths.workflows.edit
  }
};
